<template>
  <el-dialog
    title="添加员工"
    :visible.sync="dialogVisible"
    width="40%"
    class="addEmployeeDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="addEmployeeDialogForm" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="员工" prop="userIds">
            <el-select
              class="special"
              v-model="formData.userIds"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="employeeLoading"
              clearable
              multiple
            >
              <el-option v-for="item in employeeList" :key="item.userId" :label="item.userName" :value="item.userId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="所属角色">
            <el-input v-model="formData.roleName" disabled />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandle">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { approvalManagementApi } from '../../service';

  export default {
    data () {
      return {
        rules: {
          userIds: [
            { required: true, message: '请选择关联员工', trigger: 'change' }
          ]
        },
        dialogVisible: false,
        formData: {},
        employeeList: [],
        employeeLoading: false
      };
    },
    props: {
      addEmployeeShow: {
        type: Boolean,
        default: false
      },
      currentRole: {
        tupe: Object,
        default: () => {
          return {};
        }
      }
    },
    watch: {
      addEmployeeShow (val) {
        if (val) {
          this.formData.role = this.currentRole.roleId;
          this.formData.roleName = this.currentRole.roleName;
          this.$nextTick(() => {
            this.$refs.addEmployeeDialogForm.clearValidate();
          });
        } else {
          this.formData = {};
        }
        this.dialogVisible = val;
      }
    },
    methods: {
      remoteMethod (query) {
        if (query !== '') {
          this.saleLoading = true;
          approvalManagementApi.getApprovedList(query).then(res => {
            if (res.status === '200') {
              this.employeeList = res.data ? res.data : [];
            }
            this.saleLoading = false;
          });
        } else {
          this.employeeList = [];
        }
      },
      submitHandle () {
        this.$refs['addEmployeeDialogForm'].validate((valid) => {
          if (valid) {
            let params = {
              userIds: this.formData.userIds,
              role: this.formData.role
            };
            this.$emit('submitHandle', params);
          }
        });
      },
      dialogCloseHandle () {
        this.$emit('dialogCloseHandle');
      }
    }
  };
</script>

<style lang="scss" scoped>
  .addEmployeeDialog{
    ::v-deep.el-dialog{
      margin-top: 20vh!important;
      .el-dialog__body{
        min-height: 240px;
        .special > .el-input{
          height: auto;
        }
      }
    }
  }
</style>
